/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class allergies extends IceEntity {
  allergies_key: string = "";
  trans_account: string = "";
  entry_date: any = NaN;
  chronic_option: boolean = false;
  onset_of_allergy_date: any = NaN;
  resolution_date: any = NaN;
  title: string = "";
  sub_type: number = 0;
  state_type: IceTypes.problemstate = IceTypes.problemstate.stateCurrent;
  status_type: IceTypes.problemstatus = IceTypes.problemstatus.statusActive;
  adverse_reactions: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  gettablename(): string {
    return "ALLERGIES";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "REVIEWS") return true;
    else if (ColumnName == "OBSERVS") return true;
    else if (ColumnName == "GLRULES") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "REVIEWS") return "REVIEWER";
    else if (ColumnName == "OBSERVS") return "OBSERVATION";
    else if (ColumnName == "GLRULES") return "MANAGEMENT_GUIDELINE";

    return null;
  }
}
